import { render, staticRenderFns } from "./radioType.vue?vue&type=template&id=09d63508&scoped=true&"
import script from "./radioType.vue?vue&type=script&lang=js&"
export * from "./radioType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d63508",
  null
  
)

export default component.exports